import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, SectionCard, Empty } from "@/components/shared";
import { fmtDateTime } from "@/lib/format";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Immutable log of who changed what, when — old → new." testid="audit-trail" />
      <SectionCard className="!p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-100">
              <th className="px-5 py-3">Time</th><th className="px-5 py-3">User</th><th className="px-5 py-3">Role</th><th className="px-5 py-3">Action</th><th className="px-5 py-3">Entity</th><th className="px-5 py-3">Change</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-50">
                  <td className="px-5 py-3 text-xs text-slate-400 whitespace-nowrap">{fmtDateTime(r.timestamp)}</td>
                  <td className="px-5 py-3">{r.user_name}</td>
                  <td className="px-5 py-3 text-xs text-slate-500">{r.role}</td>
                  <td className="px-5 py-3"><span className="text-xs font-semibold px-2 py-0.5 rounded bg-slate-100 text-slate-700">{r.action}</span></td>
                  <td className="px-5 py-3 text-slate-600">{r.entity_type}</td>
                  <td className="px-5 py-3 text-xs font-mono text-slate-500 max-w-[280px] truncate">{r.after ? JSON.stringify(r.after) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty />}
        </div>
      </SectionCard>
    </div>
  );
}
